import { useSelector } from 'react-redux';
import { Box, Text } from '@chakra-ui/react';
import { ApplicationState } from '../../../../../store';
import { CustomHeading } from 'shared-components';
import Field from '../../../../Field/Field';
import { PrevNextButtons } from '../../../../PrevNextButtons';
import { useNavigate } from 'react-router-dom';
import ApplicantHeader from '../../../../../components/molecules/applicantHeader';
import { getApplicationData } from '@/components/pages/applicant-dashboard/sections/helpers/getApplicationData';
import { useTaskNavigation } from '@/hooks/useTaskNavigation';

export default function PrivacyPolicy() {
  const { application } = useSelector((state: ApplicationState) => state.apply);

  const { initial, current } = getApplicationData(application);
  const { accuracyOfDataConsent } = current;
  const { accuracyOfDataConsent: initialAccuracyOfDataConsent } = initial;

  const AcceptanceText = () => (
    <>
      <Text>
        Please ensure the information you have provided is correct and be sure to fill in any missing information.
      </Text>
      <Text>
        The university will use this information to process your application to a course or programme at the university.
      </Text>
      <Text>
        If an offer is made with an application which has incorrect information, this could lead to the application
        being refused or an offer withdrawn.
      </Text>
    </>
  );

  const RejectionText = () => <Text>The applicant has not agreed to the accuracy of data statement.</Text>;

  const navigate = useNavigate();
  const { nextRoute, previousRoute } = useTaskNavigation();
  return (
    <>
      <ApplicantHeader pageName="Application" />
      <Box>
        <CustomHeading level="h1" flexGrow={1} mb={8}>
          Accuracy of data
        </CustomHeading>

        <CustomHeading level="h2" mb={2} mt={6} fontSize="md">
          Data
        </CustomHeading>

        <Box>
          <Field
            leftLabel="Agreed to"
            value={accuracyOfDataConsent ? <AcceptanceText /> : <RejectionText />}
            originalValue={initialAccuracyOfDataConsent ? <AcceptanceText /> : <RejectionText />}
          />
        </Box>

        <Box mt={6}>
          <PrevNextButtons
            onPrevious={previousRoute ? () => navigate(previousRoute) : undefined}
            onNext={nextRoute ? () => navigate(nextRoute) : undefined}
          />
        </Box>
      </Box>
    </>
  );
}
